import React, { useContext } from "react";
import { ProjectDetailCard } from "components/ProjectCard";
import { ModalNew as Modal } from "components/Modal/ModalNew";
import { SubmissionSmartFieldPreviewContext } from "context/RFQSubmittedResponseContext";
import ResourceDetailCard from "components/ResourceDetailCard/ResourceDetailCard";

export const DetailModal = ({ company }) => {
	const { modalDetail, isModalOpen, setIsModalOpen } = useContext(
		SubmissionSmartFieldPreviewContext
	);

	const getDetailView = () => {
		switch (modalDetail?.type) {
			case "project":
				return (
					<ProjectDetailCard
						data={{
							...modalDetail?.data,
							company,
						}}
					/>
				);
			case "resource":
				return <ResourceDetailCard data={modalDetail?.data} />;
			default:
				return <></>;
		}
	};

	return (
		<Modal
			isOpen={isModalOpen}
			onClose={() => {
				setIsModalOpen(false);
			}}
			padding={false}
			width="600px"
			maxWidth="80vw"
		>
			{getDetailView()}
		</Modal>
	);
};
